(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /**
         * looks for the author on the page and sets it to eVar55 and prop24
         * @param trackingObject
         */

        //remove reliance on jQuery
        //var marketNewsCategory = jQuery('.article-tags').data("category");
        var marketNewsArticleTags = document.querySelectorAll('.article-tags')[0];
        if (typeof(marketNewsArticleTags) != "undefined") {
            //console.log("market news article tags found");
            var marketNewsCategory = marketNewsArticleTags.getAttribute('data-category');
            
            if (marketNewsCategory) {
                console.log('market news category', marketNewsCategory)
                //assign to 'content keyword' evar
                analytics.sitecatalyst.eVar49 = marketNewsCategory;
            }

        }

    });
})(window.nadex.marketing.analytics);